// Shared styling for the top-bar icon buttons, mirroring the reference design
// system (34×34, radius 8, muted-foreground icon on a bordered background).
export const NAV_ICON_BTN =
  "inline-flex items-center justify-center h-[34px] w-[34px] rounded-lg border border-border bg-background text-muted-foreground hover:bg-accent hover:text-accent-foreground transition-colors";
